import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Sortable } from '../sortable';
export const TableWrapper = ({ children, tableBodyContainer, isRowsSortable, data, onRowsSorted, }) => {
    if (isRowsSortable) {
        return (_jsx(Sortable, { container: tableBodyContainer, options: {
                draggable: '.MuiTableRow-root',
                handle: '.MuiTableRow-root',
            }, data: data, onSortEnd: onRowsSorted, children: children }));
    }
    return _jsx(_Fragment, { children: children });
};
export default TableWrapper;
